import Student from "./Student";
import css from "./index.module.css";
import NewStudent from "./NewStudent";
import Loading from "../../../../components/Loading";

import { useState } from "react";

/**
 * Display the list of students in a given class. Names can be appended, edited and deleted.
 * @param {Array} students List of students in the class
 * @param {String} classId 64 character uuid of the given class
 * @param {Function} setStudents update the list of students 
 */
const StudentsList = ({ students, classId, setStudents }) => {
  const [edit, setEdit] = useState("");

  if(students?.length === 0){
    return (
      <div className={css.students}>
        <div className={css.studentsList}>
          <Loading />
        </div>
          <NewStudent classId={classId} setStudents={setStudents} />
      </div>
    )
  }

  return (
    <div className={css.students}>
      
        <div className={css.studentsList}>
          {students?.map((student) => (
            <Student
              key={student.id}
              data={student}
              setStudents={setStudents}
              classId={classId}
              edit={edit === student.id}
              setEdit={setEdit}
            />
          ))}
        </div>
        <NewStudent classId={classId} students={students} setStudents={setStudents} />
    </div>
  );
};

export default StudentsList;
